(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-profile/assets/javascripts/behaviors/navigation.js') >= 0) return;  svs.modules.push('/modules/player-profile/assets/javascripts/behaviors/navigation.js');

'use strict';

svs.player_profile.behaviors.Navigation = Marionette.Behavior.extend({
  events: {
    'click .js-profile-navigation': 'onNavigationClick'
  },
  onNavigationClick(event) {
    event.preventDefault();
    const dataUrl = event.currentTarget.getAttribute('data-url');
    svs.player_profile.router.navigateIfRoute(dataUrl);
  }
});

 })(window);